import type {ValueType} from '@github-ui/custom-properties-types'
import {getEmptyValueByType} from '@github-ui/custom-properties-types/helpers'
import {TextInput} from '@primer/react'
import type {HTMLAttributes} from 'react'

import type {CustomPropertySelectPanelProps} from './CustomPropertySelectPanel'
import {
  CustomPropertyMultiSelectPanel,
  CustomPropertySingleSelectPanel,
  mixedValuePlaceholder,
} from './CustomPropertySelectPanel'

interface CustomPropertyInputProps extends CustomPropertySelectPanelProps {
  valueType: ValueType
  inputProps?: HTMLAttributes<HTMLInputElement>
  ref?: React.Ref<HTMLInputElement>
}

export const CustomPropertyInput = ({ref, ...props}: CustomPropertyInputProps) => {
  const {valueType} = props
  const value = props.propertyValue || getEmptyValueByType(valueType)

  switch (valueType) {
    case 'single_select':
      return <CustomPropertySingleSelectPanel {...props} propertyValue={value as string} />
    case 'multi_select':
      return <CustomPropertyMultiSelectPanel {...props} propertyValue={value as string[]} />
    case 'true_false':
      return (
        <CustomPropertySingleSelectPanel {...props} allowedValues={['true', 'false']} propertyValue={value as string} />
      )
    case 'string':
    case 'url':
      return <StringPropertyInput {...props} propertyValue={value as string} ref={ref} />

    default:
      return null
  }
}
CustomPropertyInput.displayName = 'CustomPropertyInput'

interface StringInputProps extends CustomPropertyInputProps {
  propertyValue: string
  ref?: React.Ref<HTMLInputElement>
}

export const StringPropertyInput = ({
  ref,
  propertyValue,
  defaultValue,
  propertyName,
  mixed,
  onChange,
  inputProps,
}: StringInputProps) => {
  const placeholder = mixed ? mixedValuePlaceholder : (defaultValue as string) || ''
  return (
    <TextInput
      ref={ref}
      block
      aria-label={propertyName}
      onChange={event => onChange(event.target.value)}
      value={propertyValue}
      placeholder={placeholder}
      {...inputProps}
    />
  )
}
StringPropertyInput.displayName = 'StringPropertyInput'
